import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React from "react";
import Divider from "@mui/material/Divider";
import { Typography } from "@mui/material";

const DeliveryModesForm = () => {
  return (
    <Stack direction='column' spacing={2}>
      <Box component={Paper} elevation={0}>
        <Box px={3} py={2}>
          <Typography variant="h4">Title Transalation</Typography>
        </Box>
        <Divider />
        <Box px={3} py={2}>
          <TextField fullWidth label='Title' id='title' />
        </Box>
      </Box>

     <Box component={Paper} elevation={0}>
        <Box px={3} py={2}>
          <Typography variant="h4">Detail Transalation</Typography>
        </Box>
        <Divider />
        <Box px={3} py={2}>
          <TextField fullWidth label='Detail' id='title' />
        </Box>
      </Box>

        <TextField fullWidth label='Price' id='price' />
    
      <Stack direction='row' spacing={2}>
        <Button variant='contained' sx={{ padding: 1 }} disabled>
          SAVE
        </Button>
        <Button variant='contained' sx={{ padding: 1 }} color='error'>
          CANCEL
        </Button>
      </Stack>
    </Stack>
  );
};

export default DeliveryModesForm;
